import LexiconEntryMatch from "./LexiconEntryMatch";

export default class LexiconEntryResult {

    private matches: LexiconEntryMatch[];

    public constructor(matches: LexiconEntryMatch[]) {
        this.matches = matches.sort((a, b) => {
            // Sort full matches to the top.
            return Number(a.isSimpleMatch()) - Number(b.isSimpleMatch());
        });
    }

    public getMatches(): LexiconEntryMatch[] {
        return this.matches;
    }

    public getMatchCount(): number {
        return this.matches.length;
    }
}
